import { SET_PARTNER_LINKS, SET_IS_INTEGRATION_ADMIN_ACCOUNT, CLEAR } from './actionTypes';
import { AftermarketPartnerState } from './types';

const initialState: AftermarketPartnerState = {
  partnerLinks: [],
  isIntegrationAdminAccount: false,
};

export const aftermarketPartnerReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case SET_PARTNER_LINKS:
      return {
        ...state,
        partnerLinks: payload,
      };
    case SET_IS_INTEGRATION_ADMIN_ACCOUNT:
      return {
        ...state,
        isIntegrationAdminAccount: payload,
      };
    case CLEAR:
      return initialState;
    default:
      return state;
  }
};
